"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttorneyPreference = exports.PersonalAttorneyNotarizationStatus = void 0;
var PersonalAttorneyNotarizationStatus;
(function (PersonalAttorneyNotarizationStatus) {
    // notarization process just started
    PersonalAttorneyNotarizationStatus["STARTED"] = "STARTED";
    // awaiting signatures from signer and attorney
    PersonalAttorneyNotarizationStatus["DOCUMENTS_SENT"] = "DOCUMENTS_SENT";
    // signatures recieved, finalizing documents
    PersonalAttorneyNotarizationStatus["DOCUMENTS_SIGNED"] = "DOCUMENTS_SIGNED";
    // finished finalizing
    PersonalAttorneyNotarizationStatus["COMPLETED"] = "COMPLETED";
})(PersonalAttorneyNotarizationStatus || (exports.PersonalAttorneyNotarizationStatus = PersonalAttorneyNotarizationStatus = {}));
var AttorneyPreference;
(function (AttorneyPreference) {
    AttorneyPreference["aven"] = "aven";
    AttorneyPreference["own"] = "own";
})(AttorneyPreference || (exports.AttorneyPreference = AttorneyPreference = {}));
